import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaTwitter, FaFacebook, FaInstagram, FaApple, FaHeart } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container">
        <motion.div 
          className="footer-content"
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <div className="footer-main">
            <div className="footer-brand">
              <motion.div 
                className="footer-logo"
                onClick={scrollToTop}
                whileHover={{ scale: 1.05 }}
                transition={{ type: "spring", stiffness: 400, damping: 17 }}
              >
                <img src="/app-icon.png" alt="DailySkin" className="logo-image" />
                <span className="logo-text">DailySkin</span>
              </motion.div>
              <p className="footer-description">
                Gamify your skincare routine with streaks, achievements, and level progression. Transform self-care into a rewarding daily habit.
              </p>
              <div className="social-links">
                <motion.a 
                  href="https://twitter.com/dailyskin_app" 
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow DailySkin on Twitter"
                  className="social-link"
                  whileHover={{ scale: 1.2, rotate: 5 }}
                  whileTap={{ scale: 0.9 }}
                >
                  <FaTwitter />
                </motion.a>
                <motion.a 
                  href="https://facebook.com/dailyskin.app" 
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow DailySkin on Facebook"
                  className="social-link"
                  whileHover={{ scale: 1.2, rotate: -5 }}
                  whileTap={{ scale: 0.9 }}
                >
                  <FaFacebook />
                </motion.a>
                <motion.a 
                  href="https://instagram.com/dailyskin_app" 
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow DailySkin on Instagram"
                  className="social-link"
                  whileHover={{ scale: 1.2, rotate: 5 }}
                  whileTap={{ scale: 0.9 }}
                >
                  <FaInstagram />
                </motion.a>
                <motion.a 
                  href="https://apps.apple.com/app/dailyskin-skincare-gamification/id1234567890" 
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Download DailySkin from the App Store"
                  className="social-link"
                  whileHover={{ scale: 1.2, rotate: -5 }}
                  whileTap={{ scale: 0.9 }}
                >
                  <FaApple />
                </motion.a>
              </div>
            </div>

            <div className="footer-links">
              <div className="link-group">
                <h4>Product</h4>
                <ul>
                  <li><a href="/#features">Features</a></li>
                  <li><a href="/#screenshots">Screenshots</a></li>
                  <li><a href="/#download">Download</a></li>
                  <li><a href="https://apps.apple.com/app/dailyskin-skincare-gamification/id1234567890" target="_blank" rel="noopener noreferrer">What's New</a></li>
                </ul>
              </div>

              <div className="link-group">
                <h4>Support</h4>
                <ul>
                  <li><Link to="/support">Help Center</Link></li>
                  <li><a href="mailto:support@dailyskin-app.com">Contact Us</a></li>
                  <li><a href="mailto:support@dailyskin-app.com?subject=Bug Report">Bug Report</a></li>
                  <li><a href="mailto:support@dailyskin-app.com?subject=Feature Request">Feature Request</a></li>
                </ul>
              </div>

              <div className="link-group">
                <h4>Company</h4>
                <ul>
                  <li><a href="mailto:info@dailyskin-app.com">About Us</a></li>
                  <li><Link to="/privacy">Privacy Policy</Link></li>
                  <li><a href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/" target="_blank" rel="noopener noreferrer">Terms of Service</a></li>
                  <li><a href="mailto:press@dailyskin-app.com">Press Kit</a></li>
                </ul>
              </div>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="footer-divider"></div>
            <div className="footer-info">
              <p className="copyright">
                © {currentYear} RIFT CO. All rights reserved.
              </p>
              <p className="made-with">
                Made with <FaHeart className="heart-icon" /> for skincare enthusiasts worldwide
              </p>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Floating back to top button */}
      <motion.button
        className="back-to-top"
        onClick={scrollToTop}
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        whileHover={{ scale: 1.1, y: -2 }}
        whileTap={{ scale: 0.9 }}
        transition={{ duration: 0.3 }}
      >
        ↑
      </motion.button>
    </footer>
  );
};

export default Footer;
